// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div class="location-container">
    <div class="location-body">
      <div class="box" ref="box">
        <div class="search-box" ref="search-box">
          <div class="search-input">
            <input ref="input" :placeholder="$t('Search...')" v-model="searchText"/>
          </div>
          <div v-if="searchText" class="search-clean" @click="onCleanInput">
            <img src="../assets/cleans.png"/>
          </div>
          <div class="search-icon">
            <img src="../assets/search.png"/>
          </div>
        </div>
        <div class="search-content" ref="search-content">
          <div class="search-content-item" v-for="(item, index) in autoCompleteChoices" :key="index"
               @click="sourceClicked(item)">
            <img :src="iconForSkySource(item)"/>
            <div class="search-content-item-col">
              <div class="search-content-item-title">{{nameForSkySource(item)}}</div>
              <div class="search-content-item-subtitle">{{typeToName(item.types[0])}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import swh from '@/assets/sw_helpers.js'
  import ClickOutside from 'vue-click-outside'
  import _ from 'lodash'

  export default {
    data: function () {
      return {
        autoCompleteChoices: [],
        searchText: '',
        lastQuery: undefined,
        showCenter: null,
        searchContentList: [],
        searchBox: false,
        location: {}
      }
    },
    props: ['value', 'floatingList'],
    watch: {
      searchText: function () {
        if (this.searchText === '') {
          this.autoCompleteChoices = []
          this.lastQuery = undefined
          return
        }
        this.refresh()
      },
    },
    computed: {
      listStyle: function () {
        return this.floatingList ? 'position: absolute; z-index: 1000; margin-top: 8px' : ''
      },
      showList: function () {
        return this.searchText !== ''
      }
    },
    methods: {
      onCleanInput() {
        this.searchText = '';
      },
      sourceClicked: function (val) {
        this.$emit('input', val)
        this.resetSearch()
      },
      resetSearch: function () {
        this.searchText = ''
      },
      refresh: _.debounce(function () {
        var that = this
        let str = that.searchText
        str = str.toUpperCase()
        str = str.replace(/\s+/g, '')
        if (this.lastQuery === str) {
          return
        }
        this.lastQuery = str
        swh.querySkySources(str, 10).then(results => {
          if (str !== that.lastQuery) {
            console.log('Cancelled query: ' + str)
            return
          }
          that.autoCompleteChoices = results
        }, err => { console.log(err) })
      }, 500),
      nameForSkySource: function (s) {
        const cn = swh.cleanupOneSkySourceName(s.match)
        const n = swh.nameForSkySource(s)
        if (cn === n) {
          return n
        } else {
          return cn + ' (' + n + ')'
        }
      },
      typeToName: function (t) {
        return swh.nameForSkySourceType(t)
      },
      iconForSkySource: function (s) {
        return swh.iconForSkySource(s)
      }
    },
    mounted: function () {
      var that = this
      const onClick = e => {
        if (that.searchText !== '') {
          that.searchText = ''
        }
      }
      const guiParent = document.querySelector('stel') || document.body
      guiParent.addEventListener('click', onClick, false)
      this.$refs['input'].focus()
    },
    directives: {
      ClickOutside
    }
  }
</script>

<style scoped>
  .location-container {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: auto;
    z-index: 1;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  .location-body {
    position: relative;
    width: 100%;
  }


  .box {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    top: 0;
    right: 30px;
  }

  button {
    border: none;
    outline: none;
    color: rgba(255, 255, 255, 0.8);
  }


  @media screen and (max-width: 960px) {
    .locate img {
      width: 14px;
      height: 14px;
    }


    input {
      border: none;
      outline: none;
      width: 100%;
    }
  }

  @media screen and (min-width: 600px) {

    .search-box {
      position: absolute;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      top: 40px;
      right: 30px;
      width: 400px;
      height: 40px;
      box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.15);
      background: rgba(54, 63, 87, 0.7);
      border-radius: 2px;
      overflow: hidden;
    }

    .search-input {
      display: flex;
      flex: 1;
      height: 100%;
      padding-left: 15px;
      width: 100%;
      z-index: 3;
    }

    .search-clean {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 40px;
    }

    .search-clean img {
      width: 18px;
      height: 18px;
    }

    .search-clean:active img {
      opacity: 0.5;
    }

    .search-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 70px;
      background: #3A5AC2;
    }

    .search-icon img {
      width: 20px;
      height: 20px;
    }

    .search-content {
      position: absolute;
      display: flex;
      flex-direction: column;
      top: 80px;
      right: 100px;
      width: 330px;
      background: rgba(66, 66, 66, 0.3);
      box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.15);
      z-index: 3;
    }

    .search-content-item {
      display: flex;
      flex-direction: row;
      padding: 5px 15px;
      width: 100%;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    .search-content-item:nth-child(1){
      border: none;
    }

    .search-content-item-col {
      display: flex;
      flex: 1;
      flex-direction: column;
      margin-left: 20px;
    }

    .search-content-item:hover {
      background: rgba(54, 63, 87, 0.7);
    }

    .search-content-item-title {
      display: inline-block;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis
    }

    .search-content-item-subtitle {
      display: inline-block;
      font-size: 13px;
      color: rgba(255, 255, 255, 0.6);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis
    }
  }

  @media screen and (max-width: 600px) {
    .box {
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      top: 0;
      left: 0;
      bottom: 25px;
      right: 10px;
    }

    .search-box {
      position: absolute;
      display: flex;
      flex-direction: row;
      align-items: center;
      top: 80px;
      left: 15px;
      right: 15px;
      height: 40px;
      box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.15);
      background: rgba(54, 63, 87, 0.7);
      border-radius: 2px;
      overflow: hidden;
    }

    .search-input {
      display: flex;
      flex: 1;
      height: 100%;
      padding-left: 15px;
      z-index: 3;
    }

    .search-clean {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 40px;
    }

    .search-clean img {
      width: 18px;
      height: 18px;
    }

    .search-clean:active img {
      opacity: 0.5;
    }

    .search-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 70px;
      background: #3A5AC2;
    }

    .search-icon img {
      width: 20px;
      height: 20px;
    }

    .search-content {
      position: absolute;
      display: flex;
      flex-direction: column;
      top: 110px;
      left: 15px;
      width: calc(100% - 100px);
      background: rgba(66, 66, 66, 0.3);
      box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.15);
      z-index: 3;
    }

    .search-content-item {
      display: flex;
      flex-direction: row;
      padding: 5px 15px;
      width: 100%;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    .search-content-item:nth-child(1){
      border: none;
    }

    .search-content-item-col {
      display: flex;
      flex: 1;
      flex-direction: column;
      margin-left: 20px;
    }

    .search-content-item:hover {
      background: rgba(54, 63, 87, 0.7);
    }

    .search-content-item-title {
      display: inline-block;
      font-size: 13px;
      color: rgba(255, 255, 255, 0.9);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis
    }

    .search-content-item-subtitle {
      display: inline-block;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.6);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis
    }
  }

  .search-input input{
    color: rgba(255, 255, 255, 0.9);
    border: none;
    outline: none;
  }
  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: rgba(255, 255, 255, 0.7);
  }
  ::-moz-placeholder { /* Firefox 19+ */
    color: rgba(255, 255, 255, 0.7);
  }
  :-ms-input-placeholder { /* IE 10+ */
    color: rgba(255, 255, 255, 0.7);
  }
  :-moz-placeholder { /* Firefox 18- */
    color: rgba(255, 255, 255, 0.7);
  }

</style>



